import { E_LANDING_PAGE_TYPE } from "@/utilities/types/LandingPage";

/**
 * Configuration for Landing Page management module
 */

export const DOMAIN_TYPES = {
  CUSTOM: E_LANDING_PAGE_TYPE.CUSTOM,
  SUBDOMAIN: E_LANDING_PAGE_TYPE.SUBDOMAIN,
};

export const DOMAIN_LABELS = {
  [DOMAIN_TYPES.CUSTOM]: "Custom Domain",
  [DOMAIN_TYPES.SUBDOMAIN]: "Subdomain",
};

// Wait time (ms) before checking domain uniqueness
export const DOMAIN_UNIQUENESS_CHECK_DEBOUNCE = 500;

// Default CName Target Domain - used only when API fails
export const DEFAULT_CNAME_TARGET = "cname.projectsg.com";

// Regex for domain checking
export const DOMAIN_REGEX = {
  // Subdomain: only allows lowercase letters, numbers, and hyphens
  SUBDOMAIN: /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/,

  // Custom domain: must be a valid domain
  CUSTOM:
    /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/,

  // Email: used for email validation
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};

// Domain error messages
export const DOMAIN_ERROR_MESSAGES = {
  REQUIRED: "Domain is required",
  INVALID_SUBDOMAIN:
    "Please enter a valid subdomain (only lowercase letters, numbers, and hyphens allowed)",
  INVALID_CUSTOM_DOMAIN: "Please enter a valid domain",
  ALREADY_TAKEN: "This domain is already taken",
  SUFFIX_NOT_ALLOWED: (suffixes: string[]) =>
    `Custom domain cannot end with: ${suffixes.join(", ")}`,
};

// Default DNS resolution time (hours)
export const DNS_RESOLUTION_TIME = 48;
